// extracted by mini-css-extract-plugin
module.exports = {"tableCell":"style_tableCell__1E32i"};